

$(function () {
  const swiper = new Swiper("#main-carousel", {
    speed: 400,
    spaceBetween: 0,
    loop: true,
    autoplay: false,
    navigation: {
      nextEl: ".main-swiper-button-next",
      prevEl: ".main-swiper-button-prev",
    },
  });

  $("#main-carousel .main-carousel-pagination-item > a").on(
    "click",
    function (ev) {
      ev.preventDefault();
      const currentIndex = $(".main-carousel-pagination-item > a").index(this);
      const activeSlide = $(
        "#main-carousel .swiper-slide:not('.swiper-slide-duplicate')[data-swiper-slide-index='" +
        currentIndex +
        "']"
      );
      const activeslideIndex = $("#main-carousel .swiper-slide").index(
        activeSlide
      );
      // console.log(currentIndex + activeslideIndex);
      swiper.slideTo(activeslideIndex);
    }
  );

  function updatePaginationActiveClass() {
    const currentIndex = swiper.activeIndex;
    console.log(currentIndex);

    $(".main-carousel-pagination-item > a").each(function (index) {
      if (
        (index === 2 && currentIndex === 0) ||
        (index === 0 && currentIndex === 4) ||
        index + 1 === currentIndex
      ) {
        $(this).removeClass("active");
      } else {
        $(this).addClass("active");
      }
    });
  }

  updatePaginationActiveClass();
  swiper.on("slideChange", updatePaginationActiveClass);

  // OTHER CAROUSELS -----------------------------------------------

  const cardSwiper = new Swiper("#card-carousel", {
    speed: 400,
    spaceBetween: 30,
    loop: false,
    slidesPerView: 1.2,
    spaceBetween: 15,
    autoplay: {
      delay: 10000,
    },
    breakpoints: {
      460: {
        slidesPerView: 1.4,
        spaceBetween: 15,
      },
      576: {
        slidesPerView: 1.8,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
    },
    pagination: {
      el: ".card-swiper-pagination",
    },
    navigation: {
      nextEl: ".card-swiper-button-next",
      prevEl: ".card-swiper-button-prev",
    },
  });

  const newsCardSwiper = new Swiper("#news-card-carousel", {
    speed: 400,
    spaceBetween: 30,
    loop: false,
    slidesPerView: 1.2,
    spaceBetween: 15,
    autoplay: {
      delay: 10000,
    },
    breakpoints: {
      460: {
        slidesPerView: 1.4,
        spaceBetween: 15,
      },
      576: {
        slidesPerView: 1.8,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
    },
    pagination: {
      el: ".newscard-swiper-pagination",
    },
    navigation: {
      nextEl: ".newscard-swiper-button-next",
      prevEl: ".newscard-swiper-button-prev",
    },
  });

  const infoSwiper = new Swiper("#info-carousel", {
    speed: 400,
    spaceBetween: 0,
    loop: $("#info-carousel").find(".swiper-slide").length > 1,
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: ".info-swiper-button-next",
      prevEl: ".info-swiper-button-prev",
    },
    pagination: {
      el: ".info-swiper-pagination",
    },
    on: {
      init: function () {
        updateBackgroundColor();
      },
      transitionEnd: function () {
        updateBackgroundColor();
      },
    },
  });

  if ($("#info-carousel").find(".swiper-slide").length > 1) {
    $(".info-swiper-button-next-copy")
      .show()
      .on("click", function () {
        infoSwiper.slideNext();
      });
    $(".info-swiper-button-prev-copy")
      .show()
      .on("click", function () {
        infoSwiper.slidePrev();
      });
  } else {
    $(".info-swiper-button-next-copy").hide();
    $(".info-swiper-button-prev-copy").hide();
  }

  // Function to update the background color of .bg-color-slider
  function updateBackgroundColor() {
    const activeSlide = document.querySelector("#info-carousel .swiper-slide-active");
    const bgColor = activeSlide.getAttribute("data-bg-color") || "#11528e";
    document.querySelector(".bg-color-slider").style.backgroundColor = bgColor;
  }

  infoSwiper.init();

  const eventSwiper = new Swiper("#event-carousel", {
    speed: 400,
    spaceBetween: 0,
    loop: false,
    autoplay: false,
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: ".event-swiper-button-next",
      prevEl: ".event-swiper-button-prev",
    },
    pagination: {
      el: ".event-swiper-pagination",
    },
  });

  $(".event-swiper-button-next-copy").on("click", function () {
    eventSwiper.slideNext();
  });

  $(".event-swiper-button-prev-copy").on("click", function () {
    eventSwiper.slidePrev();
  });
});



$(function () {
	const searchTrigger = $("#search-section");

	$("#search-trigger").on("click", function (e) {
		e.preventDefault();
		searchTrigger.addClass("opened").fadeIn();
	});

	$("#search-section-close").on("click", function (e) {
		e.preventDefault();
		searchTrigger.removeClass("opened").fadeOut();
	});
});

$(function () {
	if (!$(".masonry-grid").length) return;
	Promise.all(
		Array.from(document.images)
			.filter((img) => !img.complete)
			.map(
				(img) =>
					new Promise((resolve) => {
						img.onload = img.onerror = resolve;
					})
			)
	).then(() => {
		var msnry = new Masonry(".masonry-grid");
		msnry.layout();
	});
});

$(function () {
	Fancybox.bind("[data-fancybox]", {
		l10n: Fancybox.l10n.it,
	});
});

/*
 *  Share article
 */

$(function () {
	$(".btn-social-trigger").on("click", function (ev) {
		ev.preventDefault();
		setTimeout(function () {
			$(".sharebuttons").toggleClass("active");
		}, 200);
	});
});

$(function () {
	var clipboard = new ClipboardJS(".btn-clipboard");
	clipboard.on("success", function (e) {
		var trigger = $(e.trigger);
		trigger
			.find(".bi-clipboard")
			.removeClass("bi-clipboard")
			.addClass("bi-check-lg");
		setTimeout(function () {
			trigger
				.find(".bi-check-lg")
				.removeClass("bi-check-lg")
				.addClass("bi-clipboard");
			e.clearSelection();
		}, 2000);
	});
});
